import React from 'react';
import './Mision.css';
import misionFoto from '../Imagenes/mision_foto.jpeg';

const QuienesSomos = () => (
  <main className="mision-page">
    <section className="mision-hero" style={{ backgroundImage: `url(${misionFoto})` }}>
      <div className="mision-hero-overlay" />
      <div className="mision-container mision-hero-content reveal-on-scroll">
        <h1>Quienes Somos</h1>
        <p>
          La Direccion Provincial del Agua es el organismo tecnico responsable de planificar,
          proyectar y ejecutar politicas hidricas en Tucuman.
        </p>
      </div>
    </section>

    <section className="mision-content">
      <div className="mision-container mision-cards single">
        <article className="mision-card reveal-on-scroll">
          <h2>Direccion Provincial del Agua</h2>
          <p>
            Somos una institucion orientada al desarrollo hidraulico sostenible, la preservacion de
            cuencas y la mitigacion del riesgo hidrico. Trabajamos en articulacion con organismos
            provinciales y nacionales para impulsar infraestructura, control tecnico y gestion
            integral del recurso agua.
          </p>
        </article>
      </div>
    </section>
  </main>
);

export default QuienesSomos;

